import { render, staticRenderFns } from "./mChatbot.vue?vue&type=template&id=a1423ed4&"
import script from "./mChatbot.vue?vue&type=script&lang=js&"
export * from "./mChatbot.vue?vue&type=script&lang=js&"
import style0 from "./mChatbot.vue?vue&type=style&index=0&id=a1423ed4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports